<template>
    <div class="page-spinner">
        <i class="fa fa-cog fa-spin fa-5x" />
        <div
            v-if="progress && progress.max > 0"
            class="progress"
        >
            <div
                class="progress-bar progress-bar-striped progress-bar-animated"
                role="progressbar"
                :style="{ width: `${(progress.step / progress.max) * 100}%` }"
                :aria-valuenow="progress.step"
                aria-valuemin="0"
                :aria-valuemax="progress.max"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        progress: {
            type: Object,
            default: () => ({
                step: 0,
                max: 0,
            }),
        },
    },
};
</script>

<style lang="scss">
.page-spinner {
    position: absolute;
    pointer-events: none;
    display: flex !important;
    height: 50vh;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
    color: #1ab394; // TODO we should import (here or globally) our variables.scss to allow use of sass variables in components
    transition: opacity 1s ease-in-out;
}
.progress {
  width: 50%;
}
</style>
